import { Injectable } from '@angular/core';
import { FeesConfiguration } from '../../../lib-cart/shared/models/convenience-fee.enum';

@Injectable()
export class AwbSplitByFlightService {
    private convenienceFeesByRequest: FeesConfiguration[] = [];
    private convenienceFeesByAWB: FeesConfiguration[] = [];

    setConvenienceFeesByRequest(convenienceFees: FeesConfiguration[]): void {
        this.convenienceFeesByRequest = convenienceFees;
    }

    getConvenienceFeesByPaymentRequest(): FeesConfiguration[] {
        return this.convenienceFeesByRequest;
    }

    setConvenienceFeesByAWB(convenienceFees: FeesConfiguration[]): void {
        this.convenienceFeesByAWB = convenienceFees;
    }

    getConvenienceFeesByAWB(): FeesConfiguration[] {
        return this.convenienceFeesByAWB;
    }
}
